export default __webpack_public_path__ + "static/media/logo.17aca08d.png";